import { cn } from '@theprintbar/shared';
import { DocumentRenderer } from '../DocumentRenderer';

interface RichTextProps {
	className?: string;
	content?:
		| string
		| {
				document: any;
		  }
		| null;
}

export function RichText({ content, className }: RichTextProps) {
	const data =
		typeof content === 'string'
			? {
					document: content,
			  }
			: content;
	return data?.document?.length ? (
		<div className={cn('space-y-2', className)}>
			<DocumentRenderer {...data} />
		</div>
	) : null;
}
